var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndicatorPriorityItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9581 6.04549C15.8528 5.70742 15.5654 5.46806 15.2268 5.43609L10.6081 4.99853L8.78274 0.539087C8.64797 0.211457 8.34132 0 8.00001 0C7.6587 0 7.35193 0.211457 7.21802 0.539087L5.39267 4.99853L0.773215 5.43609C0.434587 5.4687 0.147839 5.70805 0.0418804 6.04549C-0.0634679 6.38357 0.0338237 6.75438 0.289931 6.98877L3.78132 10.1834L2.75188 14.9147C2.67656 15.2626 2.80596 15.6223 3.08258 15.831C3.23126 15.9437 3.40595 16 3.58124 16C3.73188 16 3.88264 15.9582 4.01728 15.8741L8.00001 13.3891L11.982 15.8741C12.2741 16.0563 12.6414 16.0396 12.9174 15.831C13.1941 15.6223 13.3235 15.2626 13.2481 14.9147L12.2187 10.1834L15.7101 6.98877C15.9661 6.75438 16.0635 6.38433 15.9581 6.04549Z",
    fill: "#F9B609"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicatorPriorityItem);
export default __webpack_public_path__ + "static/media/icon-indicator-priority-item.7ae6d3bd357dc201548e939e7d662ab7.svg";
export { ForwardRef as ReactComponent };